<template><option :value="value" :disabled="disabled" :data-sb-null="value === null ? 'true' : null"><slot /></option></template>
<script>
export default {
    name: "SbFormSelectOption",
    props: {
        value: { default: null },
        disabled: { type: Boolean, default: false },
    },
};
</script>
